// extracted by mini-css-extract-plugin
export default {"wrapper":"AccordPart_wrapper__cjGsr"};